import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { getFirebaseAuth } from "./firebase";

export const subscribeToAuth = (onChange) =>
  onAuthStateChanged(getFirebaseAuth(), onChange);

export const signUp = async (email, password) => {
  const credential = await createUserWithEmailAndPassword(
    getFirebaseAuth(),
    email,
    password
  );
  return credential.user;
};

export const signIn = async (email, password) => {
  const credential = await signInWithEmailAndPassword(
    getFirebaseAuth(),
    email,
    password
  );
  return credential.user;
};

export const resetPassword = async (email) => {
  await sendPasswordResetEmail(getFirebaseAuth(), email, {
    url: `${window.location.origin}/login`,
  });
};

export const signOutUser = async () => {
  await signOut(getFirebaseAuth());
};

export const getIdToken = async () => {
  const user = getFirebaseAuth().currentUser;
  if (!user) return null;
  return user.getIdToken();
};
